// extracted by mini-css-extract-plugin
export var loadingSpinner = "_60-1";
export var standaloneTable = "_60-0";